import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { PortalAuthService } from '../auth/portal-auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const portalAuth = inject(PortalAuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      // Portal: troca de senha obrigatória exigida pelo servidor.
      if (
        error instanceof HttpErrorResponse &&
        error.status === 403 &&
        (error.error as { code?: string } | null)?.code === 'PASSWORD_CHANGE_REQUIRED'
      ) {
        portalAuth.requirePasswordChange();
        void router.navigateByUrl('/cliente/account/security');
        return throwError(() => error);
      }

      if (error instanceof HttpErrorResponse && error.status === 401) {
        const isPublicInternalAuth =
          req.url.includes('/auth/login') ||
          req.url.includes('/auth/google') ||
          req.url.includes('/auth/request-password-reset') ||
          req.url.includes('/auth/validate-password-reset-token') ||
          req.url.includes('/auth/reset-password');
        const isPublicPortalAuth =
          req.url.includes('/cliente/auth/login') ||
          req.url.includes('/cliente/auth/google') ||
          req.url.includes('/cliente/auth/request-password-reset') ||
          req.url.includes('/cliente/auth/validate-token') ||
          req.url.includes('/cliente/auth/redeem-token');

        // Login/token endpoints devem devolver erro para a tela tratar (sem redirect global).
        if (isPublicInternalAuth || isPublicPortalAuth) {
          return throwError(() => error);
        }

        const onPortalArea = router.url.startsWith('/cliente') || req.url.includes('/cliente/');

        if (onPortalArea) {
          portalAuth.clearSession();
          void router.navigateByUrl('/cliente/login');
        } else {
          auth.clearSession();
          void router.navigateByUrl('/login');
        }
      }

      return throwError(() => error);
    })
  );
};
